<section class="edp-rating" *ngIf="ratingStatus$ | async as ratingStatus" [ngClass]="{'opened-keyboard': openedKeyboard}">
    <div class="edp-rating-container" *ngIf="!ratingStatus.state && !ratingStatus.showMessage">
        <div class="edp-rating-close" (click)="close()">
            <i class="icon-edponline-Bop-071"  aria-hidden="true"></i>
        </div>
        <div class="d-flex justify-content-start flex-column align-items-center w-100">
            <div class="edp-rating-logo">
                <img src="./assets/images/stella-images/edp_small_light_logo.png" width="40" height="40" alt="Edp Online" class="img-fluid">
            </div>
            <div class="edp-rating-title">
                {{ 'pt.edp.edponline.rating.title' | translate }}
            </div>
            <div class="edp-rating-description">
                {{ 'pt.edp.edponline.rating.description' | translate }}
            </div>

            <div class="edp-rating-vote">
                <div class="edp-rating-vote-item" *ngFor="let item of rating" (click)="rate(item)">
                    <i class="icon-edponline-Bra-151" [ngClass]="{'edp-main-01': item.active}"  aria-hidden="true"></i>
                </div>
            </div>
            <div *ngIf="score" class="d-flex flex-column w-100">
                <div class="edp-rating-message-label">
                    <span *ngIf="score.value === 1">{{ 'pt.edp.edponline.rating.rated1' | translate }}</span>
                    <span *ngIf="score.value === 2">{{ 'pt.edp.edponline.rating.rated2' | translate }}</span>
                    <span *ngIf="score.value === 3">{{ 'pt.edp.edponline.rating.rated3' | translate }}</span>
                    <span *ngIf="score.value === 4">{{ 'pt.edp.edponline.rating.rated4' | translate }}</span>
                    <span *ngIf="score.value === 5">{{ 'pt.edp.edponline.rating.rated5' | translate }}</span>
                </div>
                <textarea *ngIf="score.value <= 3" class="edp-rating-message-field" maxlength="200"
                    [(ngModel)]="message" placeholder="{{placeholder}}" (click)="openedKeyboard = true" (blur)="openedKeyboard = false"></textarea>
            </div>
        </div>

        <div *ngIf="!score" class="edp-rating-skip">
            <div class="edp-rating-remind-later edp-text-seaweed-green" (click)="skip('Avaliado_retry')">
                {{ 'pt.edp.edponline.rating.remindMeLater' | translate }}
            </div>
            <div class="edp-rating-no-thanks edp-text-black" (click)="skip('Fechado')">
                {{ 'pt.edp.edponline.rating.noThanks' | translate }}
            </div>
        </div>

        <button *ngIf="score && score.value <= 3" type="button" class="btn btn-primary w-100" (click)="submitRate()">
            {{ 'pt.edp.edponline.rating.submit' | translate }}
        </button>

        <button *ngIf="score && score.value > 3" type=" button" class="btn edp-btn-secondary w-100" (click)="rateStore()" [edpExternalLink]="storeLink | translate">
            {{ 'pt.edp.edponline.rating.ratingStore' | translate }}
        </button>
    </div>
    <div class="edp-rating-container" *ngIf="ratingStatus.showMessage && ratingStatus.messageType === 'SUCCESS'">
        <div class="edp-rating-close" (click)="closeMessage()">
            <i class="icon-edponline-Bop-071"  aria-hidden="true"></i>
        </div>
        <div class="edp-rating-success">
            <i class="icon-edponline-Bra-072 icon"  aria-hidden="true"></i>
            <h1 class="message" [innerHTML]="'pt.edp.edponline.rating.successMessage' | translate"></h1>
        </div>
    </div>
    <div class="edp-rating-container" *ngIf="ratingStatus.showMessage && ratingStatus.messageType === 'ERROR'">
        <div class="edp-rating-close" (click)="closeMessage()">
            <i class="icon-edponline-Bop-071"  aria-hidden="true"></i>
        </div>
        <div class="edp-rating-error">
            <i class="icon-edponline-Bra-025 icon"  aria-hidden="true"></i>
            <h1 class="message" [innerHTML]="'pt.edp.edponline.rating.errorMessage' | translate"></h1>
        </div>
    </div>
</section>